<template lang="pug">
.modal-container
    .content-modal
        h3.titulo-modal {{ $t('mensagens.menuMapa.territorio') }}:
        h5.texto-modal {{ data.nome }}

    .content-modal
        h3.titulo-modal {{ $t('mensagens.menuMapa.localidade') }}:
        h5.texto-modal {{ data.localidade }}

    .content-modal
        h3.titulo-modal(v-if="ambientePy") {{ $t('mensagens.menuMapa.produtor') }}:
        h3.titulo-modal(v-else) {{ $t('mensagens.menuMapa.pessoa') }}:
        h5.texto-modal(
            v-for='(representante, index) in data.representante.representantes',
            :key='index'
        ) {{ representante }}

    .botao-modal
        BaseButton.botao-style(type='primary', @click='mudarRota(data.id)') {{ $t('mensagens.menuMapa.realizarDiagnostico') }}

    .botao-modal
        span.botao-link-style(@click='mudarRotaVisaoGeralTerritorio(data.id)') {{ $t('mensagens.menuMapa.visualizar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'PopupMapaTerritorio',

    components: {
        BaseButton
    },

    props: {
        mapa: {
            type: Object,
            required: true
        },

        data: {
            type: Object,
            required: true
        },

        ambientePy: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {};
    },

    methods: {
        mudarRota(id) {
            this.$router.push(`/territorio/socioambiental/${id}`);
        },

        mudarRotaVisaoGeralTerritorio(id) {
            this.$router.push(`/territorio/${id}`);
        }
    }
};
</script>

<style lang="scss" scoped>
.titulo-modal {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #3b3b3b;
}

.texto-modal {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3b3b3b;
}

.modal-container {
    flex: auto;
    flex-direction: column;
}

.content-modal {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 15px;
}

.botao-modal {
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    padding-bottom: 15px;
}

.botao-style {
    width: 100%;
}

.botao-link-style {
    width: 100%;
    justify-content: center;
    align-self: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #114adc;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
}
</style>
